module.exports = __webpack_public_path__ + "img/maestro.68348e89.svg";